import { MouseEvent, useEffect, useState } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { stepForward } from '../../../actions/apartments';
import { NextStep } from '../../../actions/types';
import { allDefined, allValid } from '../../../utils/validation/general';
import Button from '../../../components/Button';
import { useSetStepValidationFailed } from './StepValidationContext';
interface NextStepButtonProps extends WithTranslation {
    doNextStep: NextStep;
    submit: boolean;
    customLabel?: string;
    disabled?: boolean;
    id?: string;
    setIsEmpty?: any;
    toValidate?: any;
    toCheck?: any;
    secondary?: boolean;
    customClickHandler?: any;
    externalIsLoading?: boolean;
}
const SubmitButton = ({ t, doNextStep, customLabel, id, submit, disabled, setIsEmpty, toValidate, toCheck, secondary, customClickHandler, externalIsLoading }: NextStepButtonProps) => {
    const [type, setType] = useState('button');
    const [isLoading, setIsLoading] = useState(false);
    const setStepFailed = useSetStepValidationFailed();
    useEffect(() => {
        if (externalIsLoading) {
            setIsLoading(true);
        }
        else if (externalIsLoading === false) {
            setIsLoading(false);
        }
    }, [externalIsLoading]);
    useEffect(() => {
        submit ? setType('submit') : setType('button');
    }, [submit]);
    const customProps: any = {};
    /** Palauttaa true, jos vaihe on kunnossa ja lomakkeen saa lähettää */
    const handleClick = (arg?: any, fields?: any): boolean => {
        const allRequiredDefined = arg ? allDefined(arg) : true;
        const allFieldsValid = fields ? allValid(fields) : true;
        if (allRequiredDefined && allFieldsValid) {
            setIsEmpty(false);
            setTimeout(() => setIsLoading(true), 0);
            return true;
        }
        setIsEmpty(true);
        setStepFailed(true);
        return false;
    };
    return (<>
      <Button fullWidth type={type} id={id} variant={secondary ? 'outlined' : 'contained'} onClick={(event: MouseEvent<HTMLButtonElement>) => {
            if (customClickHandler) {
                setTimeout(() => setIsLoading(true), 0);
                customClickHandler();
            }
            else if (setIsEmpty && (toValidate || toCheck)) {
                // Submit-tyyppinen nappi lähettäisi lomakkeen tarkistuksesta riippumatta: estetään, jos vaihe ei ole kunnossa
                if (!handleClick(toValidate, toCheck)) {
                    event.preventDefault();
                }
            }
        }} style={{
            display: submit ? 'flex' : 'none',
        }} disabled={disabled} loading={isLoading} {...customProps}>
      {customLabel == undefined
            ? t('apartment.actions.submit')
            : typeof customLabel == 'string'
                ? t(`${customLabel}`)
                : customLabel}
    </Button>
    </>);
};
const mapDispatchToProps = (dispatch: Dispatch) => ({
    doNextStep: () => dispatch(stepForward())
});
export default connect(null, mapDispatchToProps)(withTranslation()(SubmitButton)) as any;
